import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	plans: {
		data: [],
		error: null,
		loading: false,
		totalCount: 0,
		tableParams: {
			page: 0,
			size: 10,
		},
	},
	plan: { error: null, loading: false, data: null },
	//
	//editedPlan: { error: null, loading: false, data: null },
	//removedPlan: { error: null, loading: false, data: null },
	createdPlan: { error: null, loading: false, data: null },
	//
};

const { actions, reducer } = createSlice({
	name: 'plans',
	initialState,
	reducers: {
		createPlan: (state, { payload }) => {
			state.createdPlan = {
				...state.createdPlan,
				data: null,
				error: null,
				loading: true,
			};
		},
		createPlanFailure: (state, { payload }) => {
			state.createdPlan = {
				...state.createdPlan,
				error: payload,
				loading: false,
			};
		},
		createPlanSuccess: (state, { payload }) => {
			state.createdPlan = {
				...state.createdPlan,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getEnabledPlans: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.plans = {
				...state.plans,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getEnabledPlansFailure: (state, { payload }) => {
			state.plans = {
				...state.plans,
				error: payload,
				loading: false,
			};
		},
		getEnabledPlansSuccess: (state, { payload }) => {
			state.plans = {
				...state.plans,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getPlans: (state, { payload }) => {
			const { saveConfig = true, ...restPayload } = payload;
			state.plans = {
				...state.plans,
				...(saveConfig ? { tableParams: restPayload } : {}),
				error: null,
				loading: true,
			};
		},
		getPlansFailure: (state, { payload }) => {
			state.plans = {
				...state.plans,
				error: payload,
				loading: false,
			};
		},
		getPlansSuccess: (state, { payload }) => {
			state.plans = {
				...state.plans,
				data: payload.body,
				totalCount: payload.meta.totalCount,
				error: null,
				loading: false,
			};
		},
		getPlanByName: (state, { payload }) => {
			state.plan = {
				...state.plan,
				data: null,
				error: null,
				loading: true,
			};
		},
		getPlanByNameFailure: (state, { payload }) => {
			state.plan = {
				...state.plan,
				error: payload,
				loading: false,
			};
		},
		getPlanByNameSuccess: (state, { payload }) => {
			state.plan = {
				...state.plan,
				data: payload,
				error: null,
				loading: false,
			};
		},
		getPlanByClientId: (state, { payload }) => {
			state.plan = {
				...state.plan,
				data: null,
				error: null,
				loading: true,
			};
		},
		getPlanByClientIdFailure: (state, { payload }) => {
			state.plan = {
				...state.plan,
				error: payload,
				loading: false,
			};
		},
		getPlanByClientIdSuccess: (state, { payload }) => {
			state.plan = {
				...state.plan,
				data: payload,
				error: null,
				loading: false,
			};
		},
	},
});

export const {
	createPlan,
	createPlanFailure,
	createPlanSuccess,
	getEnabledPlans,
	getEnabledPlansFailure,
	getEnabledPlansSuccess,
	getPlans,
	getPlansFailure,
	getPlansSuccess,
	getPlanByName,
	getPlanByNameFailure,
	getPlanByNameSuccess,
	getPlanByClientId,
	getPlanByClientIdFailure,
	getPlanByClientIdSuccess,
} = actions;

export { default as plansSaga } from './sagas';

export default reducer;
